export const siteInfo = {
  name: "Dreameer Education",
  tagline: "Online Tuition & Admission Consultancy",
  description:
    "Personalised one-to-one tuition with verified tutors, live doubt support, mock reviews, and a parent tracking dashboard.",
  phone: "+91 9507505612",
  email: "info@dreameer.in",
  whatsappNumber: "919507505612",
  officeHours: "Mon-Sat | 9 AM-7 PM",
  siteUrl: "https://dreameer.in/",
};

export const stats = [
  { value: "10K+", label: "Happy Students" },
  { value: "500+", label: "Verified Tutors" },
  { value: "4.8/5", label: "Average Rating" },
];

export const parentSignals = [
  "🎯 Goal-based matching",
  "📚 Board + entrance prep",
  "📹 Recorded class support",
  "📈 Parent progress updates",
];

export const goalPrograms = [
  { symbol: "\u{1F4DA}", title: "CBSE & ICSE Boards" },
  { symbol: "\u{1F3EB}", title: "State Board Exams" },
  { symbol: "\u269B", title: "NEET / JEE Foundation" },
  { symbol: "\u{1F6E1}", title: "Sainik School Prep" },
  { symbol: "\u{1F3AF}", title: "Navodaya Vidyalaya" },
  { symbol: "\u{1F947}", title: "Olympiad Training" },
  { symbol: "\u{1F3DB}", title: "Bihar BSSC 2025" },
  { symbol: "\u2708", title: "NDA / Defence Prep" },
  { symbol: "\u{1F393}", title: "CUET (UG)" },
  { symbol: "\u{1F4BB}", title: "ADCA / Skills" },
];

export const programPackages = [
  {
    title: "One-to-One Tuition",
    badge: "Most Popular",
    price: "Rs 800 / hour",
    description:
      "Highly personalised study plans, dedicated doubt solving, and recorded session support.",
    action: "Book via WhatsApp",
  },
  {
    title: "Small Group Batch",
    price: "Rs 250 / student / hr",
    description:
      "Affordable group learning for up to five students with regular doubt clearance sessions.",
    action: "Enquire Now",
  },
  {
    title: "Crash Course",
    price: "Rs 13,500 / 20 hrs",
    description:
      "An intensive revision sprint focused on mocks, chapter rescue, and quick feedback loops.",
    action: "Buy Course",
  },
  {
    title: "Skill Courses",
    price: "Custom Pricing",
    description:
      "ADCA, basic computer skills, spoken English, typing, and practical employability modules.",
    action: "Ask Details",
  },
];

export const subjects = [
  { title: "Mathematics", detail: "Algebra, Calculus, Geometry" },
  { title: "Physics", detail: "Mechanics, Optics, Numericals" },
  { title: "Chemistry", detail: "Organic, Physical, Inorganic" },
  { title: "Biology", detail: "Botany, Zoology, Diagrams" },
  { title: "Social Science", detail: "History, Geography, Civics" },
  { title: "English", detail: "Grammar, Writing, Speaking" },
  { title: "Economics / Accounts", detail: "Commerce Streams" },
  { title: "Business Studies", detail: "Management Basics" },
  { title: "Computer / ADCA", detail: "Programming, Office, IT" },
  { title: "Languages", detail: "Hindi, Sanskrit, French" },
];

export const howItWorks = [
  {
    number: "1",
    title: "Book a Demo",
    description:
      "Schedule a free WhatsApp diagnostic session so our counselor can map the learner's current level.",
  },
  {
    number: "2",
    title: "Personal Plan",
    description:
      "We recommend the right tutor, preparation path, class format, and weekly schedule.",
  },
  {
    number: "3",
    title: "Live Classes",
    description:
      "Attend one-to-one or small group sessions with notes, regular doubt support, and revision help.",
  },
  {
    number: "4",
    title: "Mock and Review",
    description:
      "Track attendance, tests, and tutor notes through the parent dashboard experience.",
  },
];

export const liveClassHighlights = [
  "Sample live session preview",
  "Real classroom interaction",
  "One-to-one and small group options",
  "Recorded sessions and notes",
  "Board and entrance focus",
  "Flexible timings",
];

export const liveClasses = [
  {
    title: "Maths (CBSE)",
    schedule: "Mon, Wed, Fri | 6:30 PM to 7:30 PM",
    tutor: "Shri Priya Verma",
    level: "Class 9-12",
  },
  {
    title: "Spoken English (Beginner)",
    schedule: "Tue and Thu | 5:00 PM to 6:00 PM",
    tutor: "Shri Ramesh",
    level: "Beginner",
  },
];

export const successStories = [
  {
    name: "Rohan",
    line:
      '"I improved from 55 to 86 in one term after mock-focused practice and weekly doubt sessions. The recorded classes were a lifesaver for revision."',
    meta: "Rohan, Class 10",
    track: "Sainik Foundation + Board Practice",
  },
  {
    name: "Sanya",
    line:
      '"The Navodaya practice tests increased my speed and accuracy - selected in the final list. Doubt solving felt much stronger than offline coaching."',
    meta: "Sanya, Class 6",
    track: "Navodaya + Olympiad Training",
  },
  {
    name: "Anjali",
    line:
      '"Crash course plus targeted mocks helped me secure a top percentile in board mock exams. The group batch felt focused and affordable."',
    meta: "Anjali, Class 12",
    track: "Board Revision + Mock Reviews",
  },
  {
    name: "Pooja (Parent)",
    line:
      '"The parent dashboard gives me complete peace of mind. I can see attendance, scores, and tutor feedback without repeatedly asking for updates."',
    meta: "Mrs. Pooja (Parent)",
    track: "One-to-One Tuition Parent",
  },
];

export const faqItems = [
  {
    question: "How does the demo work?",
    answer:
      "You book a free 30-minute diagnostic session, we assess the learner's current level, and then recommend the right tutor, schedule, and academic plan.",
  },
  {
    question: "What payment options are available?",
    answer:
      "This starter ships with a payment modal and Cashfree serverless examples. In production you can connect Cashfree, UPI, cards, or payment links through the documented serverless templates.",
  },
  {
    question: "Do you provide study material?",
    answer:
      "Yes. Tutors can share worksheets, revision notes, mock tests, and recordings depending on the selected program.",
  },
  {
    question: "What happens if I miss a class?",
    answer:
      "Recorded sessions and rescheduling support help students catch up, and parents can review tutor notes from the dashboard.",
  },
];

export const counselorSlots = [
  "Today | 5:30 PM IST",
  "Tomorrow | 11:00 AM IST",
  "Tomorrow | 6:45 PM IST",
  "Saturday | 4:00 PM IST",
];

export const pageMeta = {
  "/": {
    title: "Dreameer Education | Online Tuition and Admission Consultancy",
    description:
      "Personalised one-to-one tuition with expert verified tutors for Classes 7-12, boards, NEET, JEE, CUET, NDA, Sainik, Navodaya, and skill courses.",
  },
  "/marketplace": {
    title: "Tutor Marketplace | Dreameer Education",
    description:
      "Browse Dreameer's verified tutor marketplace with filters, sorting, ratings, pricing, and instant WhatsApp demo booking.",
  },
  "/booking-success": {
    title: "Booking Success | Dreameer Education",
    description: "Your Dreameer demo request has been saved locally and shared to WhatsApp.",
  },
  "/admin": {
    title: "Admin Panel | Dreameer Education",
    description:
      "Manage tutors, view leads and bookings, export CSV files, and review the Firebase Auth migration guide.",
  },
  "/parent-dashboard": {
    title: "Parent Dashboard | Dreameer Education",
    description:
      "Mock parent dashboard with route protection, progress graphs, attendance snapshots, and tutor updates.",
  },
  default: {
    title: "Dreameer Education",
    description: "Structured plans, quality tutors, personalised feedback, and tracked progress.",
  },
};
